










































































import Vue from 'vue'
import auth from '../auth'
import Menu from '@/components/Menu.vue'
import IconNotification from '@/components/icons/IconNotification.vue'
import IconMail from '@/components/icons/IconMail.vue'
import IconHelp from '@/components/icons/IconHelp.vue'
import IconDownload from '@/components/icons/IconDownload.vue'
import IconKebab from '@/components/icons/IconKebab.vue'
import Popover from '@/components/Popover.vue'
import ExportAll from '@/components/ExportAll.vue'
import Button from '@/components/Button.vue'
import { Navigation, Breakpoints } from '@/interfaces'
import EmailPopupButton from '@/components/EmailPopupButton.vue'
import { MessageHub } from '../event-hub'

export default Vue.extend({
  name: 'Navigation',
  components: {
    Menu,
    IconNotification,
    IconMail,
    IconHelp,
    IconDownload,
    IconKebab,
    Popover,
    ExportAll,
    EmailPopupButton,
    Button,
  },
  data() {
    return {
      isOpen: false,
    }
  },
  computed: {
    currentBreakpoint(): string {
      return this.$store.getters.currentBreakpoint
    },
    isVisible(): Navigation[] {
      return this.$store.state.navigation.isVisible
    },
    iconColor(): string {
      return this.currentBreakpoint === 'xl' ? '#0090da' : '#ffffff'
    },
    notificationBadgeNumber(): number {
      return this.$store.state.notifications.alertCount
    },
    userName(): string {
      return this.$store.state.userName
    },
  },
  methods: {
    handleLogoutClick() {
      auth.signOut()
    },
    handleKebabClick() {
      this.isOpen = !this.isOpen
      this.isOpen
        ? document.addEventListener('click', this.handleDocumentClick)
        : document.removeEventListener('click', this.handleDocumentClick)
    },
    handleDocumentClick(event: any) {
      if (!this.$el || !this.elementContains(this.$el, event.target)) {
        this.isOpen = false
        document.removeEventListener('click', this.handleDocumentClick)
      }
    },
    elementContains(elm: any, otherElm: any) {
      if (typeof elm.contains === 'function') {
        return elm.contains(otherElm)
      }
      return false
    },
    handleNotificationClick() {
      MessageHub.$emit('openNotifications')
    },
  },
})
